import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { LatLngExpression } from 'leaflet';
import markerImage from "../../assets/img/map.gif"
import { FaMapMarker } from 'react-icons/fa';

const Map: React.FC = () => {
    const mapCenter: LatLngExpression = [-21.45007349917093, 47.09801584294146];
    return (
        <div className='contact__content'>
            <div className='map__content'>
                <MapContainer center={mapCenter} zoom={13} style={{ height: '360px', width: '100%' }}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker position={mapCenter} icon={L.icon({
                        iconUrl: markerImage, iconSize: [20, 30],
                        iconAnchor: [25, 50]
                    })}>
                        <Popup>
                            <div className="message__map">
                                Chez moi 👇
                            </div>
                        </Popup>
                    </Marker>
                </MapContainer>
                <div className='lieu__content'>
                    <FaMapMarker className='icon__lieu' />   <span>Fianarantsoa , Andohan'Ivory</span>

                </div>
            </div>
        </div>


    );
};

export default Map;
